import {
    login
} from '@/api/login';
import {
    getUserInfo
} from '@/api/user';
import router from '@/router'
import {
    message
} from 'ant-design-vue';
import Cookies from "js-cookie";
export default {
    namespaced: true,
    state: () => ({
        token: localStorage.getItem('token') || Cookies.get('token') || '',
        userInfo: localStorage.getItem('lginfo') || Cookies.get('lginfo') || ''
    }),
    mutations: {
        setToken(state, token) {
            state.token = token
            localStorage.setItem('token', token)
        },
        setUserInfo(state, obj) {
            state.userInfo = obj;
            localStorage.setItem('lginfo', obj)
            Cookies.set('lginfo', obj);
            Cookies.set('lginfo', obj, {
                path: '/',
                domain: '.zaimanhua.com',
                expires: new Date(Date.now() + 24 * 60 * 60 * 1000)
            });
        },
    },
    actions: {
        // 登录
        login({
            commit
        }, userInfo) {
            return new Promise((resolve, reject) => {
                // 登录成功
                login(userInfo).then(res => {
                    if (res.errno === 0) {
                        commit('setToken', res.data.user.token);
                        // 记得注释token
                        Cookies.set('lginfo', JSON.stringify(res.data.user));
                        Cookies.set('token', res.data.user.token);
                        Cookies.set('lginfo', JSON.stringify(res.data.user), {
                            path: '/',
                            domain: '.zaimanhua.com',
                            expires: new Date(Date.now() + 24 * 60 * 60 * 1000)
                        });
                        Cookies.set('token', res.data.user.token, {
                            path: '/',
                            domain: '.zaimanhua.com',
                            expires: new Date(Date.now() + 24 * 60 * 60 * 1000)
                        });
                        const redirectPage = Cookies.get('redirectPage');
                        if (redirectPage) {
                            message.success('登录成功！');
                            Cookies.remove('redirectPage', {
                                path: '/',
                                domain: '.zaimanhua.com'
                            });
                            // 二次检查，若仍存在则强制覆盖为空
                            if (Cookies.get('redirectPage')) {
                                Cookies.set('redirectPage', '', {
                                    path: '/',
                                    domain: '.zaimanhua.com',
                                    expires: new Date(0) // 立即过期
                                });
                            }
                            setTimeout(() => {
                                router.replace('/upload')
                            }, 1000)
                        } else {
                            message.success('登录成功！即将跳转到首页');
                            setTimeout(() => {
                                router.replace('/')
                            }, 2500);
                        }
                        resolve()
                    } else {
                        message.error(res.errmsg);
                    }
                }).catch(err => {
                    reject(err)
                })
            })
        },

        // 获取用户信息
        async GetInfo({
            commit
        }) {
            try {
                const res = await getUserInfo();
                if (res) {
                    commit('setUserInfo', JSON.stringify(res.data.userInfo));
                } else {
                    throw new Error('获取用户信息失败');
                }
            } catch (error) {
                throw error;
            }
        }
    }
}